import {
  Box,
  Breadcrumbs,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Select from "react-select";
import MainScreen from "../../Components/Navbar/MainScreen";
import CustomTextArea from "../../Components/CustomTextArea/CustomTextArea";
import { connect } from "react-redux";
import axios from "axios";
import AXIOS from "../../Utils/AXIOS";
import toast, { Toaster } from "react-hot-toast";

function SearchDatabase(props) {
  const navigate = useNavigate();

  const [chatLoading, setChatLoading] = useState(false);

  const [jobDescription, setJobDescription] = useState("");

  const handleSearchDb = () => {
    // navigate("/search-database-details");

    //sgenaiapi.azurewebsites.net/resume_analytics/ask?question=3%20years%20experience
    https: if (jobDescription != "") {
      setChatLoading(true);

      axios
        .post(
          AXIOS.defaultURL +
            AXIOS.resume_analytics_ask +
            "?question=" +
            jobDescription,
          { question: jobDescription },
          {
            headers: {
              Authorization: `Bearer ${props.token}`,
              "x-api-key": `${props.token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          setChatLoading(false);

          navigate("/search-database-details", {
            state: {
              AskedAnswer: response.data,
              AskedQuestion: jobDescription,
            },
          });
        })
        .catch((err) => {
          setChatLoading(false);
          toast.error("Something went wrong");
        });
    } else {
      toast.error("Please enter job description");
    }
  };
  return (
    <MainScreen>
      <Box
        sx={{
          p: 2,
        }}
      >
        <Toaster />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            // marginTop: 15,
            backgroundColor: "#fff",
            // padding: 5,
          }}
        >
          <div
            style={{
              display: "flex",
              // marginTop: 5,
            }}
          >
            <div
              className="gray-arrow-container"
              onClick={() => {
                navigate("/home");
              }}
            >
              True ATS+
            </div>
            <div className="blue-arrow-container">Search Talent</div>
          </div>
        </div>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Box
            sx={{
              width: 200,
            }}
          >
            <Typography sx={{ color: "text.primary" }}>
              Pre Saved Job Description
            </Typography>
            <Select options={[]} />
          </Box>
        </Box>

        <CustomTextArea
          label="Enter your job description"
          multiline
          rows={4} // Number of visible rows
          fullWidth
          variant="outlined"
          margin="normal"
          onChange={(e) => {
            setJobDescription(e.target.value);
          }}
          onKeyDown={(e) => {
            // If only Enter is pressed (without Shift or Ctrl)
            if (e.key === "Enter" && !e.shiftKey && !e.ctrlKey) {
              e.preventDefault(); // Prevent newline
              handleSearchDb(); // Trigger submit
            }
          }}
        />
        <Box
          display="flex"
          gap={3}
          sx={{
            justifyContent: "space-between",
          }}
        >
          {/* <Button
            variant="outlined"
            onClick={() => {
              navigate("/search-database-details");
            }}
          >
            Search In Database
          </Button> */}
          <Button
            variant="contained"
            onClick={() => {
              handleSearchDb();
            }}
            sx={{
              backgroundColor: "#14bc9a",
              width: 200,
              color: "#fff",
              "&:hover": {
                backgroundColor: "#119a80",
              },
            }}
          >
            {chatLoading ? (
              <CircularProgress
                size={"25px"}
                sx={{
                  color: "#fff",
                }}
              />
            ) : (
              "Search Talent"
            )}
          </Button>
          <Button
            variant="contained"
            onClick={() => {}}
            sx={{
              backgroundColor: "#fd815e",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#fd815e",
              },
            }}
          >
            Save as Favorite
          </Button>
        </Box>
      </Box>
    </MainScreen>
  );
}

const mapStateToProps = (state) => ({
  token: state.auth.token,
});

export default connect(mapStateToProps)(SearchDatabase);
